import React from 'react';
import { cn } from '../../utils/cn';

const BackgroundComposer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
  [key: string]: unknown;
}) => {
  return (
    <div className={cn('relative', className)}>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default BackgroundComposer;
